import React from 'react';

import { IMenuByTypesItem } from '@r1-frontend/api-domru/api-content/v2/menu/by-types/dto/IMenuByTypesItem';
import Card from '@r1-frontend/entities/Layout/Header/mobile/components/Card';

import * as ST from './styled';

interface IProps {
    item: IMenuByTypesItem,
    onClick: (item: string, menuType?: string) => void,
    clickHandler?: () => void,
    isPromoted: boolean,
}

const Category = ({ item, onClick, clickHandler, isPromoted }: IProps): JSX.Element => {
    return (
        <ST.CardWrapper>
            {item?.children?.map((child, index) => (
                <Card
                    key={index}
                    item={child}
                    onClick={onClick}
                    clickHandler={clickHandler}
                    isPromoted={isPromoted}
                />
            ))}
        </ST.CardWrapper>
    );
};

export default Category;
